<template>
  <v-dialog persistent v-model="show" width="450" :transition="show ? 'dialog-bottom-transition' : 'dialog-top-transition'">
    <v-card class="dialog-header-radius" :key="nKeyRefresh">
      <v-toolbar height="45" elevation="0" dense>
        <v-toolbar-title class="text-title-modal">
            <v-icon color="success">mdi-check-circle</v-icon>
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-title class="font-weight-medium"> {{ oEquivalencia.ttlArchivoListo }} </v-card-title>
      <v-card-text class="pb-0">
        <p>{{ oEquivalencia.msgArchivoListo }}</p>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
            <v-col class="pa-2">
                <v-btn @click="onClose" outlined color="primary" block rounded>
                    {{ oEquivalencia.btnCancelar }}
                </v-btn>
            </v-col>
            <v-col class="pa-2">
                <v-btn block color="primary" rounded :disabled="oArchivos?.aExcel?.length === 0" @click="onDescargar"> 
                    {{ oEquivalencia.btnDescargar }}
                </v-btn>
            </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ExportarLicencias",
  props: {
    bModalDescargas: {
      type: Boolean,
      default: false,
    },
    oArchivos: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: false,
      oEquivalencia: this.$store.state.jsIdioma.oEquivalencias,
      nKeyRefresh: 0
    };
  },
  methods: {
    onClose() {
      this.show = false;
      this.$emit("onClose");
    },
    onDescargar() {
      if(this.oArchivos?.aExcel?.length > 0) {
        window.open(this.oArchivos?.aExcel[0]?.url, '_blank');
      }
    }
  },
  watch: {
    bModalDescargas() {
      this.show = this.bModalDescargas;
      this.nKeyRefresh++;
    },
    show() {
      if (!this.show) this.$emit("onClose");
    },
  },
};
</script>